import { render } from "./CoachFilter.vue?vue&type=template&id=48720e32&scoped=true"
import script from "./CoachFilter.vue?vue&type=script&lang=js"
export * from "./CoachFilter.vue?vue&type=script&lang=js"

import "./CoachFilter.vue?vue&type=style&index=0&id=48720e32&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48720e32"

export default script